// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ObZ6","toggle":"styles_toggle__3zedU","preview":"styles_preview__WfJBu"};